import React from "react";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import CONFIG from "../../../utils/config";
import { useNavigate } from "react-router";
import _ from "lodash";
import {
  ProductCardPriceInfo,
  SessionKeys,
  convertMinutesToHoursAndMinutes,
  convertSecondsToMins,
  convertTimeFormat,
  getProcureInfo,
} from "../../../utils/AppUtils";
import { Spinner } from "react-bootstrap";

import {
  getFreeVideos,
  getFreeVideosClear,
} from "../../../redux/video/actions";
import CommonComponentEntity from "./CommonComponentEntity";

const FreeVideos = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const freeVideosDataResponse = useSelector((state) => state.video.freeVideos);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getFreeVideosData();
    return () => {
      dispatch(getFreeVideosClear());
    };
  }, []);

  const navigateToView = (video) => {
    let paramsReq ={
      code: video?.crscd,
      source: _.lowerCase(
        video?.source
      ),
      is_paid: video?.priceInfo.isFree,
      is_home: true
    }
    if (!_.isEmpty(video.categoryId)) {
      paramsReq.catId = video?.categoryId[0];
    }
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    // let url = `/video-view-page/${video?.product_id}/?source=${_.lowerCase(
    //   video?.source
    // )}&code=${video?.crscd}&is_paid=${video?.priceInfo.isFree}`;
    // if (!_.isEmpty(video.categoryId)) {
    //   url += `&catId=${video?.categoryId[0]}`;
    // }
    let url = `/video-view-page/${video?.product_id}/?c=${encodedUrl}`;
    navigate(url);
  };

  const [newCardData, setNewCardData] = useState(
    CONFIG.INITIAL_PRODUCT_CARD_DATA
  );

  const formatProductCardData = (coursesList) => {
    let prodArr = [];

    for (let video of coursesList) {
      let tags = [];
      let logoURL = "";
      let btnTitle = "Explore";

      logoURL = video.provider_logo;

      if (video?.provider) {
        tags.push(video?.provider?.provider_display_name);
      }
      tags.push("Video");
      tags.push(`${video.views} View${video.views > 1 ? "s" : ""}`);
      tags.push(convertTimeFormat(video?.second, true));

      let priceInfo = getProcureInfo(video.purchased_info);
      video.priceInfo = priceInfo;

      prodArr.push({
        id: video?.id,
        is_like: video?.is_like ? video?.is_like : false,
        is_bookmark: video?.is_bookmark ? video?.is_bookmark : false,
        dbId: video?.list_id,
        productType: video?.type,
        productOrigin: _.toLower(video?.source),
        title: video.title,
        logoURL: logoURL,
        logoAltText: "VD",
        bannerURL: video.thumbnail,
        tagsArray: tags,
        description: video.long_description,
        duration: convertTimeFormat(video.second, true),
        showHeader: true,
        showProviderIcon: true,
        showPlayButton: true,
        showLikeMenu: true,
        showProgress: false,
        showBody: false,
        showFooter: true,
        btnTitle: btnTitle,
        btnAction: () => navigateToView(video),
        descAction: () => {},
        bannerAction: () => navigateToView(video),
        cardClassName: "",
        footerLineComp: !_.isEmpty(priceInfo)
          ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
          : "",
        view: video.views,
        priceInfo: priceInfo,
        rightBtnIcon: "/images/arrow-right.svg",
        leftBtnIcon: "",
        isLoading: false,
      });
    }
    console.log("PROD ARR", prodArr);
    setNewCardData(prodArr);
  };

  const [userCount, setUserCount] = useState();

  useEffect(() => {
    if (!_.isEmpty(freeVideosDataResponse)) {
      if (freeVideosDataResponse.status === "success") {
        const list1 = freeVideosDataResponse.payload.payload?.list;
        setUserCount(freeVideosDataResponse.payload.payload?.user_count);
        if (!_.isEmpty(list1)) {
          formatProductCardData(list1);
          setIsLoading(false);
        } else {
          setNewCardData([]);
          setIsLoading(false);
        }
      } else {
        setNewCardData([]);
        setIsLoading(false);
      }
    }
  }, [freeVideosDataResponse]);

  const getFreeVideosData = () => {
    setNewCardData(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    setIsLoading(true);
    dispatch(
      getFreeVideos({
        module: "freeVideos",
        postData: {},
      })
    );
  };

  useEffect(() => {
    setNewCardData(CONFIG.INITIAL_PRODUCT_CARD_DATA);
  }, []);

  return (
    <>
      <CommonComponentEntity
        // isLoading={isLoading}
        newCardData={newCardData}
        heading={"Most watched videos"}
        subHeading={`👍🏻 ${
          userCount < 10 ? "10" : userCount
        }+ learners have found these useful`}
        viewAllAction={"/learn/videos"}
        type={"video"}
      />
    </>
  );
};

export default FreeVideos;
